import {connect} from '@store/@common';

import {SkillCancellableSource} from 'sources/SkillSource';

import {SkillsField} from './skills-field';

const mapStateToProps = {};

const mapActionsToProps = {
  searchSkills: SkillCancellableSource.search,
};

export default connect(SkillsField, mapStateToProps, mapActionsToProps);
